import type { FormattedCity, GeoAddress } from '@features/cities/types'

/** Проверяет совпадение названия города с городом или населённым пунктом адреса. */
export const isGeoEqualCityName = (
  cityName: string,
  geo: GeoAddress,
): boolean => {
  const city = geo.city.toLowerCase()
  const locality = geo.locality.toLowerCase()

  return (
    cityName === city || cityName === locality || locality.includes(cityName)
  )
}

/** Возвращает город из списка, совпавший с географическим адресом. */
export const findCityByGeo = (
  cities: FormattedCity[],
  geo: GeoAddress | null,
): FormattedCity | undefined => {
  if (!geo) {
    return undefined
  }

  return cities.find((city) =>
    isGeoEqualCityName(city.visibleName.toLowerCase(), geo),
  )
}
